import { ParentType, ResolvedType, StringIndexedObject } from "./parser/types.js"

export type Component = {
  /**
   * Exported name of the component used to import the component from the library / path
   */
  exportName: string

  /**
   * How the component export was discovered
   */
  exportType?: "explicit-export" | "inferred-export" | "star-export"

  /**
   * Path to the component file
   */
  componentPath: string

  /**
   * Description of the component
   */
  description: string

  /**
   * Tags of the component
   */
  tags: StringIndexedObject<string> | null

  /**
   * Map of the component's name to their descriptors
   */
  properties: Record<string, ComponentProperty>
}

export type ComponentProperty = {
  /**
   * Type of control used to edit the property
   */
  // control: ControlTypeInfo

  /**
   * Default value of the property
   */
  defaultValue: string | undefined

  /**
   * Code name of the property
   */
  name: string

  /**
   * False if the property is optional (annotated with `?`), true otherwise
   */
  required: boolean

  /**
   * Resolved type of the property
   */
  type: ResolvedType

  /**
   * Declarations of the property
   */
  declarations: ParentType[] | undefined

  /**
   * Tags of the property
   */
  tags: StringIndexedObject<string> | undefined

  /**
   * Description of the property
   */
  description: string
}
